'use client';
import { arrayOf } from '@s7/utils';

var isIncludesSafe = function(a, b) {
    return b !== undefined && arrayOf(a).includes(b);
};

export { isIncludesSafe };
